// Team-Filter: Multi-Select-Checkbox-Pills (eine je Abteilung). Kein „Alle";
// alle Pills sind standardmäßig aktiv (gehakt). Eine Mitarbeiter-Card wird
// angezeigt, wenn die Pill ihrer Abteilung aktiv ist. „Filter zurücksetzen"
// reaktiviert alle Pills und erscheint nur, solange eine Pill abgewählt ist.
// Trifft die Auswahl niemanden, erscheint ein Leerzustand ([data-filter-empty])
// mit Hinweistext + Reset-Button. Kein Inline-JS (§8). Markup:
//   <div data-filter>
//     <button data-filter-toggle="2" aria-pressed="true" class="is-active">…</button>
//     <button data-filter-reset hidden>…</button>            <!-- Leiste -->
//     <div data-filter-item data-filter-tags="2">…</div>
//     <p data-filter-empty hidden>… <button data-filter-reset>…</button></p>
//   </div>
import { animateFilter } from "./filteranim.js";

export function initFilters() {
  document.querySelectorAll("[data-filter]").forEach((root) => {
    const items = root.querySelectorAll("[data-filter-item]");
    const toggles = [...root.querySelectorAll("[data-filter-toggle]")];
    const resets = root.querySelectorAll("[data-filter-reset]");
    const barReset = root.querySelector("[data-filter-reset]"); // erster = Leiste
    const empty = root.querySelector("[data-filter-empty]");
    if (toggles.length === 0) return;

    const apply = () => {
      const active = new Set(
        toggles
          .filter((t) => t.classList.contains("is-active"))
          .map((t) => t.dataset.filterToggle),
      );
      const matchCount = [...items].filter((it) =>
        active.has(it.dataset.filterTags),
      ).length;
      animateFilter(items, (it) => active.has(it.dataset.filterTags));
      if (barReset) barReset.hidden = active.size === toggles.length;
      if (empty) empty.hidden = matchCount > 0;
    };

    toggles.forEach((t) =>
      t.addEventListener("click", () => {
        const on = t.classList.toggle("is-active");
        t.setAttribute("aria-pressed", on ? "true" : "false");
        apply();
      }),
    );

    resets.forEach((r) =>
      r.addEventListener("click", () => {
        toggles.forEach((t) => {
          t.classList.add("is-active");
          t.setAttribute("aria-pressed", "true");
        });
        apply();
      }),
    );
  });
}
